import { toast } from 'material-react-toastify';

import { Text } from '@/components/shared/Text/Text';

interface EmailCopyProps {
  onClick: () => void;
  userEmail: string;
}

export const EmailCopy = ({ onClick, userEmail }: EmailCopyProps) => {
  return (
    <div className="col-span-3 flex items-center">
      <Text.Normal>{userEmail}</Text.Normal>

      <div className="ml-auto flex items-center">
        <img onClick={onClick} src={'/icons/pencil.svg'} className="cursor-pointer" alt="edit" />

        <img
          onClick={() => {
            navigator.clipboard.writeText(userEmail);
            toast.info('Email copied to clipboard');
          }}
          src={'/icons/copy.svg'}
          className="cursor-pointer ml-4"
          alt="copy"
        />
      </div>
    </div>
  );
};
